var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81454 0.0231024C5.77788 0.00783473 5.73891 0 5.69994 0H0.300029C0.134095 0 0 0.134397 0 0.300031V12.3C0 12.4656 0.134093 12.6 0.300029 12.6H8.69997C8.8659 12.6 9 12.4656 9 12.3L8.9999 3.30008C8.9999 3.26111 8.99207 3.22203 8.9768 3.18547C8.96153 3.14861 8.93963 3.11556 8.91171 3.08764L5.91245 0.0878466C5.88452 0.0603249 5.85158 0.038427 5.81471 0.0231606L5.81454 0.0231024ZM5.99986 1.02415L7.97561 3.00001H5.99986V1.02415ZM8.39989 11.9999H0.60011L0.60001 0.599867H5.40001V3.29983C5.40001 3.46547 5.5341 3.59986 5.70004 3.59986H8.4L8.39989 11.9999Z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 6.75005L4.0502 8.55005L6.7502 6.30005",
    stroke: "#2F54EB",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.0f625f37053b00f98171e0b3733afe0f.svg";
export { ForwardRef as ReactComponent };